export default {
  close: '닫기',
  dataIterator: {
    pageText: '{2} 중 {0}-{1}',
    noResultsText: '일치하는 항목이 없습니다.',
    loadingText: '불러오는 중...',
  },
  dataTable: {
    itemsPerPageText: '페이지 당 행 수:',
    ariaLabel: {
      sortDescending: ': 내림차순 정렬. 정렬을 취소하려면 활성화하세요.',
      sortAscending: ': 오름차순 정렬. 내림차순 정렬을 위해 활성화하세요.',
      sortNone: ': 정렬하지 않음. 오름차순 정렬을 위해 활성화하세요.',
    },
    sortBy: 'Sort by',
  },
  dataFooter: {
    itemsPerPageText: '페이지 당 항목 수:',
    itemsPerPageAll: '전체',
    nextPage: '다음 페이지',
    prevPage: '이전 페이지',
    firstPage: '첫 페이지',
    lastPage: '마지막 페이지',
  },
  datePicker: {
    itemsSelected: '{0} 선택됨',
  },
  noDataText: '이용할 수 없습니다',
  carousel: {
    prev: '이전 화면',
    next: '다음 화면',
  },
  calendar: {
    moreEvents: '{0} 더보기',
  },
  fileInput: {
    counter: '{0} files',
    counterSize: '{0} files ({1} in total)',
  },
}
